import moment from 'moment';
import * as React from 'react';
import { useState } from 'react';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { PrizesScore } from '../../../components/LeaderboardComponents/PrizesScore';
import { IPrizeLogFilter } from '../../../models/slotMachines';
import { useLeaderboardPrizesQuery } from '../../../queries/Leaderboard';
import { DailySlider } from './DailySlider';
import { EmptyState } from './EmptyState';

const dayFilter = (day: moment.MomentInput): IPrizeLogFilter => ({
	date: {
		end: moment(day).add(1, 'day').startOf('day').toDate(),
		start: moment(day).startOf('day').toDate(),
	},
});

export const Prizes: React.FC = () => {
	const [filter, setFilter] = useState<IPrizeLogFilter>(() => dayFilter(undefined));
	const { data, isError, isPending } = useLeaderboardPrizesQuery({ filter });

	if (isPending) {
		return <LoadingSpinner />;
	}

	const emptyState =
		isError && !data ? (
			<EmptyState title="Couldn't load prizes." description='It will try again shortly.' />
		) : !data?.length ? (
			<EmptyState title='No data yet.' />
		) : null;

	return (
		<PrizesScore
			data={data ?? []}
			renderEmptyState={emptyState}
			renderFilter={<DailySlider onChange={day => setFilter(dayFilter(day))} />}
		/>
	);
};
